import React, { ReactElement, useEffect, useState } from 'react';
import { Input } from '../../../../Input';
import { Select } from '../../../../Select';
import Modal from 'react-modal';
import { useRouteLoaderData } from 'react-router-dom';
import './functionaryForm.css';
import {
  dependenteSchema,
  funcionarioSchema,
} from '../../data/schema/functionarysSchema';
import {
  changeCivilStatus,
  changeGender,
  changeIssuingAgency,
  changeParentage,
  changeUF,
} from '../../../../../utils/ChangeArrays';
import { DependentForm } from '../DependentsForm/DependentFormTeste';
import { z } from 'zod';
import { useFunctionaryExistsStore } from '../../../../../stores/useFunctionaryStore';
import { useVidaCountStore } from '../../../../../stores/useQuantidadeVidas';
import {
  useDependentIdStore,
  useDependentOpenModalDataStore,
  useDependentShowStore,
} from '../../../../../stores/useDependentStore';
import { useIncludeFunctionaryForm } from '../../../../../contexts/IncludeFunctionaryFormProvider';
import { GoForwardButton } from '../../GoForwardButton';
import { getSiglaSeExistir } from '../../../../../utils/getSiglaIfExists';
import { isValidCPF } from '../../../../../utils/ValidarCPF';
import { useVigenciaStore } from '../../../../../stores/usePaymentStore';
import { useBoostedPlanDataStore } from '../../../../../stores/useBoostedPlanDataStore';
import toast, { Toaster } from 'react-hot-toast';
import Loading from '../../../../icons/Loading';
import { CartIcon } from '../../../../icons/CartIcon';
import { useCepValidator } from '../../../../../utils/useCepValidor';

Modal.setAppElement('#root');
export function FunctionaryForm(): ReactElement {
  const {
    register,
    handleSubmit,
    goToNextForm,
    onSubmit,
    errors,
    watch,
    setValue,
  } = useIncludeFunctionaryForm();
  const dados: any = useRouteLoaderData('Empresa-token');
  const setDepId = useDependentIdStore(state => state.setId);
  const [hasDependentes, setHasDependentes] = useState(false);
  const hasNewDependentes = useDependentShowStore(x => x.data);
  const setShow = useDependentShowStore(x => x.setdependentOpenModalData);
  const [dependentesCadastrados, setDependentesCadastrados] = useState<any[]>(
    [],
  );
  const { validarCep } = useCepValidator();
  const FuncionarioCadastrado = useFunctionaryExistsStore(x => x.existe);
  const setFuncionarioCadastrado = useFunctionaryExistsStore(x => x.setExiste);
  const vigencia = useVigenciaStore(x => x.vigencia);
  const initialPlanData = useBoostedPlanDataStore(x => x.data);
  const setinicialPlanData = useBoostedPlanDataStore(x => x.setBoostPlanData);
  const cpf = watch(`user.funcionario.cpf`);
  const dataFuncionario = watch('cadastrado');
  const setDependentOpenModal = useDependentOpenModalDataStore(
    state => state.setdependentOpenModalData,
  );
  const CEP = watch(`user.funcionario.address.cep`);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const cleanedCPF = cpf?.replace(/[^0-9]/g, '');
    if (cleanedCPF && cleanedCPF.length == 11) {
      if (isValidCPF(cleanedCPF)) {
        validafuncionario(cleanedCPF);
      } else {
        toast.error('cpf invalido!!!');
        setValue('user.funcionario.cpf', '');
      }
    }
  }, [cpf]);

  useEffect(() => {
    fetchPlanData();
    const inicialValue = watch('inicial');
    if (inicialValue) {
      setValue('user.funcionario.nome', inicialValue.nome);
      setValue('user.funcionario.Celular', inicialValue.celular);
    }
    if (dados) {
      setValue('user.codEmpresa', dados.id_empresa);
      setValue('user.codVendedor', dados.codVendedor);
    }
  }, []);

  const fetchPlanData = async () => {
    const urlPlan = process.env.REACT_APP_OG_GET_PLAN_DETAILS_COMPANY;
    const Plan = await fetch(`${urlPlan}${dados.TokenVd}`);

    const retorno = await Plan.json();
    setinicialPlanData(retorno);
  };
  const validafuncionario = async (cpf: string) => {
    const url = process.env.REACT_APP_GET_ASSOCIADO_CPF;
    const token = process.env.REACT_APP_TOKEN_S4E_V2;
    const Associado = await fetch(`${url}?token=${token}&cpfAssociado=${cpf}`);

    const retorno = await Associado.json();
    const ativos = [1, 16];
    const funcionarioCadastrado = retorno.dados.find(
      x =>
        x.codigoDaEmpresa == dados.id_empresa &&
        x.dependentes.some(
          d => d.codigoGrauParentesco == 1 && ativos.includes(d.codigoSituacao),
        ),
    );
    if (funcionarioCadastrado) {
      toast(
        'Funcionário já cadastrado, caso queira adicionar dependentes, clique em "Adicionar Dependente"',
      );
      setFuncionarioCadastrado(true);
      setValue('cadastrado', funcionarioCadastrado);
      setValue('inicial.idFuncionario', funcionarioCadastrado.codigo);
      if (funcionarioCadastrado.dependentes) {
        const dep = funcionarioCadastrado.dependentes.filter(
          x => x.codigoGrauParentesco != 1,
        );
        setDependentesCadastrados(dep);
        setHasDependentes(true);
      }
    } else {
      setFuncionarioCadastrado(false);
    }
  };

  const validaDados = async () => {
    setLoading(true);

    try {
      if (vigencia) {
        setValue('user.dtInicioVigencia', vigencia);
      }

      if (FuncionarioCadastrado) {
        const user = watch('user');
        const { funcionario, ...userSemFuncionario } = user;
        setValue('user', userSemFuncionario, { shouldValidate: true });
      }

      if (dependentes) {
        if (
          dependentes.length > 0 &&
          (dependentes[0].nome === '' || dependentes[0].nome === undefined)
        ) {
          removeClick(0);
        }
      }

      const validatedFuncionario = funcionarioSchema.safeParse(
        watch('user.funcionario'),
      );
      if (!validatedFuncionario.success) {
        alert('Por favor, preencha todos os campos obrigatórios corretamente.');
        handleSubmit(onSubmit)();
        return;
        //const funcionarioErrors = validatedFuncionario.error.flatten().fieldErrors;
      }

      const cep = watch('user.funcionario.address.cep');
      const validateCep = await validarCep(cep);
      if (!cep || !validateCep) {
        alert('Por favor, insira um CEP válido antes de continuar.');
        return;
      }

      await handleSubmit(onSubmit)();
    } catch (error) {
      console.error('Erro ao validar dados:', error);
    } finally {
      setLoading(false);
    }
  };

  const getCEPDetails = async (e: string) => {
    const formatedCep = e.replace(/[^0-9]/g, '');
    if (formatedCep.length < 8) {
      return;
    }
    const CEPInformations = await fetch(
      `${process.env.REACT_APP_URL_BASE}/api/redeatendimento/Endereco?token=${process.env.REACT_APP_TOKEN_S4E_V2}&cep=${formatedCep}`,
      {
        method: 'POST',
      },
    ).then(response => response.json());
    if (CEPInformations.dados != null) {
      setValue(
        `user.funcionario.address.city`,
        CEPInformations.dados.Municipio,
      );
      setValue(
        'user.funcionario.address.tipoLogradouro',
        String(CEPInformations.dados.IdTipoLogradouro),
      );
      setValue(
        'user.funcionario.address.bairro',
        String(CEPInformations.dados.IdBairro),
      );
      setValue(
        'user.funcionario.address.municipio',
        String(CEPInformations.dados.IdMunicipio),
      );
      setValue(
        'user.funcionario.address.ufId',
        String(CEPInformations.dados.IdUf),
      );
      setValue(
        'user.funcionario.address.ufDescription',
        String(CEPInformations.dados.Uf),
      );
      setValue(
        `user.funcionario.address.neighborhood`,
        CEPInformations.dados.Bairro,
      );
      setValue(
        `user.funcionario.address.street`,
        CEPInformations.dados.Logradouro,
      );
      const SiglaUf = getSiglaSeExistir(CEPInformations.dados.Uf);
      const UF = initialPlanData.listaUFS.find(x => x.sigla == SiglaUf).Id;
      setValue(`user.funcionario.address.uf`, String(UF));

      return CEPInformations;
    } else {
      toast.error('cep não encontrado na Base');
      setValue('user.funcionario.address.cep', '');
    }
  };
  const carregamentos = async () => {
    if (initialPlanData && initialPlanData.type === 'bussiness') {
      changeGender(initialPlanData.listaSexos);
      changeCivilStatus(initialPlanData.listaEstadosCivil);
      changeParentage(initialPlanData.listaParentescos);
      changeUF(initialPlanData.listaUFS);
      changeIssuingAgency(initialPlanData.listaOrgaosExpedidor);
    }
  };

  useEffect(() => {
    carregamentos();
  }, [initialPlanData]);

  useEffect(() => {
    if (CEP) {
      getCEPDetails(CEP);
    }
  }, [CEP]);

  const dependentes = watch('newDependents');

  const editClick = (index: number) => {
    setDepId(index);
    setDependentOpenModal(true);
  };

  const removeClick = (ind: number) => {
    const currentDependentes = watch('newDependents') || [];
    const updatedDependentes = currentDependentes.filter(
      (_, index) => index !== ind,
    );
    setValue('newDependents', updatedDependentes);
    if (updatedDependentes.length === 0) {
      setShow(false);
    }
  };

  return (
    <div>
      <h2 className="min-[748px]:text-xl text-lg font-medium text-primary-main mb-8">
        Dados Funcionário
      </h2>
      <form onSubmit={handleSubmit(onSubmit)}>
        {!FuncionarioCadastrado ? (
          <>
            <div className="grid min-[748px]:grid-cols-2 grid-cols-1 gap-6">
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  CPF <span className="text-red-500">*</span>
                </label>
                <Input
                  label={''}
                  placeholder="CPF"
                  activateMask
                  mask="999.999.999-99"
                  errorMessage={errors.user?.funcionario?.cpf?.message}
                  {...register(`user.funcionario.cpf`, {
                    required: 'CPF é obrigatório',
                  })}
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Nome completo <span className="text-red-500">*</span>
                </label>
                <Input
                  label={''}
                  placeholder="Nome completo"
                  errorMessage={errors.user?.funcionario?.nome?.message}
                  {...register('user.funcionario.nome', {
                    required: 'Nome completo é obrigatório',
                  })}
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Data de nascimento <span className="text-red-500">*</span>
                </label>
                <Input
                  label={''}
                  activateMask
                  mask="99/99/9999"
                  placeholder="Data de nascimento"
                  errorMessage={errors.user?.funcionario?.dtNascimento?.message}
                  {...register('user.funcionario.dtNascimento')}
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Nome da mãe <span className="text-red-500">*</span>
                </label>
                <Input
                  label=""
                  placeholder="Nome da mãe"
                  errorMessage={errors.user?.funcionario?.motherName?.message}
                  {...register(`user.funcionario.motherName`)}
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  E-mail <span className="text-red-500">*</span>
                </label>
                <Input
                  label=""
                  placeholder="E-mail"
                  errorMessage={errors.user?.funcionario?.email?.message}
                  {...register(`user.funcionario.email`)}
                />
              </div>
              <Input
                label="Matrícula"
                placeholder="Matrícula"
                errorMessage={errors.user?.funcionario?.matricula?.message}
                {...register(`user.funcionario.matricula`)}
              />
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  RG <span className="text-red-500">*</span>
                </label>
                <Input
                  label=""
                  placeholder="RG"
                  errorMessage={errors.user?.funcionario?.rg?.message}
                  {...register(`user.funcionario.rg`)}
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Órgão expedidor <span className="text-red-500">*</span>
                </label>
                <Select
                  label=""
                  options={[]}
                  optionsFull={initialPlanData.listaOrgaosExpedidor}
                  placeholder="Órgão expedidor"
                  errorMessage={errors.user?.funcionario?.orgao?.message}
                  {...register(`user.funcionario.orgao`)}
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  UF órgão expedidor <span className="text-red-500">*</span>
                </label>
                <Select
                  label=""
                  options={[]}
                  optionsFull={initialPlanData.listaUFS}
                  placeholder="Órgão expedidor UF"
                  errorMessage={errors.user?.funcionario?.orgaoUF?.message}
                  {...register(`user.funcionario.orgaoUF`)}
                />
              </div>
              <Input
                label="CNS- Opcional"
                placeholder="CNS"
                errorMessage={errors.user?.funcionario?.cns?.message}
                {...register(`user.funcionario.cns`)}
              />
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Gênero <span className="text-red-500">*</span>
                </label>
                <Select
                  label=""
                  options={[]}
                  optionsFull={initialPlanData.listaSexos}
                  placeholder="Gênero"
                  errorMessage={errors.user?.funcionario?.sexo?.message}
                  {...register(`user.funcionario.sexo`)}
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Estado civil <span className="text-red-500">*</span>
                </label>
                <Select
                  label=""
                  options={[]}
                  optionsFull={initialPlanData.listaEstadosCivil}
                  placeholder="Estado civil"
                  errorMessage={errors.user?.funcionario?.estCivil?.message}
                  {...register(`user.funcionario.estCivil`)}
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Celular <span className="text-red-500">*</span>
                </label>
                <Input
                  label=""
                  activateMask
                  mask="(99) 99999-9999"
                  placeholder="Celular"
                  errorMessage={errors.user?.funcionario?.Celular?.message}
                  {...register(`user.funcionario.Celular`)}
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Telefone Secundário{' '}
                  <span className="text-gray-500">(Opcional)</span>
                </label>
                <Input
                  label=""
                  activateMask
                  mask="(99) 99999-9999"
                  placeholder="Telefone"
                  errorMessage={errors.user?.funcionario?.telefoneRes?.message}
                  {...register(`user.funcionario.telefoneRes`)}
                />
              </div>
            </div>
            <h2 className="min-[748px]:text-xl text-lg font-medium text-primary-main mb-4 mt-4">
              Endereço
            </h2>
            <div className="grid grid-cols-2 gap-8">
              <Input
                activateMask
                mask="99999-999"
                label="CEP"
                className="w-full"
                placeholder="CEP"
                errorMessage={errors.user?.funcionario?.address?.cep?.message}
                {...register(`user.funcionario.address.cep`)}
              />
              <Input
                label="Número"
                placeholder="Digite o seu número"
                errorMessage={
                  errors.user?.funcionario?.address?.number?.message
                }
                {...register(`user.funcionario.address.number`)}
              />
            </div>
            <div className="grid grid-cols-1 gap-8">
              <Input
                label="Logradouro"
                placeholder="Digite o seu logradouro"
                errorMessage={
                  errors.user?.funcionario?.address?.street?.message
                }
                {...register(`user.funcionario.address.street`)}
              />
            </div>
            <div className="grid grid-cols-2 gap-8">
              <Input
                label="Complemento"
                placeholder="Digite o seu complemento"
                errorMessage={
                  errors.user?.funcionario?.address?.complement?.message
                }
                {...register(`user.funcionario.address.complement`)}
              />
              <Input
                label="Cidade"
                placeholder="Digite sua cidade"
                errorMessage={errors.user?.funcionario?.address?.city?.message}
                {...register(`user.funcionario.address.city`)}
              />
            </div>
            <div className="grid grid-cols-3 gap-8">
              <Input
                label="Bairro"
                placeholder="Digite o seu bairro"
                errorMessage={
                  errors.user?.funcionario?.address?.neighborhood?.message
                }
                {...register(`user.funcionario.address.neighborhood`)}
              />
              <Select
                label="UF"
                options={[]}
                optionsFull={initialPlanData.listaUFS}
                placeholder="UF"
                errorMessage={errors.user?.funcionario?.address?.uf?.message}
                {...register(`user.funcionario.address.uf`)}
              />
            </div>
          </>
        ) : (
          <div className="w-full flex flex-col">
            <h2 className="min-[748px]:text-xl text-lg font-semibold text-primary-main mb-4 mt-4">
              Dados do Titular
            </h2>
            <div className="w-full min-[748px]:mt-4 rounded-xl p-2">
              <div className="grid grid-cols-4 gap-6">
                <div className="col-span-2">
                  <label>Nome:</label> {dataFuncionario.nome}
                </div>
                <div className="col-span-1">
                  <label>CPF:</label> {dataFuncionario.cpf}
                </div>
                <div className="col-span-1">
                  <label>Matricula:</label> {dataFuncionario.matricula}
                </div>
                <div className="col-span-1"></div>
              </div>
              <h2 className="min-[748px]:text-[2rem] text-2xl font-semibold text-primary-main">
                Dependentes
              </h2>
              {hasDependentes && (
                <div className="w-full min-[748px]:mt-4 rounded-xl p-2">
                  <h3 className="min-[748px]:text-[1.5rem] text-2xl font-semibold text-primary-main">
                    Existentes
                  </h3>
                  <table width="98%" style={{ margin: '2%' }}>
                    <thead>
                      <tr>
                        <th style={{ textAlign: 'center' }}>Nome</th>
                        <th style={{ textAlign: 'center' }}>sexo</th>
                        <th style={{ textAlign: 'center' }}>Nascimento</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dependentesCadastrados?.map((dependente, index) => (
                        <React.Fragment key={index}>
                          <tr>
                            <td style={{ textAlign: 'center' }}>
                              {dependente.nomeDependente}
                            </td>
                            <td style={{ textAlign: 'center' }}>
                              {dependente.sexo == 'F'
                                ? 'Feminino'
                                : 'Masculino'}
                            </td>
                            <td style={{ textAlign: 'center' }}>
                              {dependente.dataNascimento}
                            </td>
                          </tr>
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        )}
        {hasNewDependentes && (
          <div className="w-full min-[748px]:mt-4 rounded-xl p-2">
            {FuncionarioCadastrado && (
              <h3 className="min-[748px]:text-[1.5rem] text-2xl font-semibold text-primary-main">
                Novos
              </h3>
            )}
            <table width="98%" style={{ margin: '2%' }}>
              <thead>
                <tr>
                  <th style={{ textAlign: 'center' }}>Nome</th>
                  <th style={{ textAlign: 'center' }}>CPF</th>
                  <th style={{ textAlign: 'center' }}>Nascimento</th>
                  <th style={{ textAlign: 'center' }}>Ações</th>
                </tr>
              </thead>
              <tbody>
                {dependentes?.map((dependente, index) => (
                  <React.Fragment key={index}>
                    <tr>
                      <td style={{ textAlign: 'center' }}>{dependente.nome}</td>
                      <td style={{ textAlign: 'center' }}>{dependente.cpf}</td>
                      <td style={{ textAlign: 'center' }}>
                        {dependente.dtNascimento}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        <button type="button" onClick={() => editClick(index)}>
                          Editar
                        </button>
                        {' / '}
                        <button
                          type="button"
                          onClick={() => removeClick(index)}
                        >
                          Remover
                        </button>
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <DependentForm />
      </form>
      <div
        style={{
          display: 'flex',
          marginTop: '25px',
          flexDirection: 'row-reverse',
        }}
      >
        <GoForwardButton
          disabled={loading}
          addBackButton
          onForwardClick={validaDados}
          Icon={loading ? Loading : CartIcon}
          desktopText={loading ? '' : 'concluir adesão'}
          mobileText={loading ? '' : 'concluir adesão'}
        />
      </div>
    </div>
  );
}

export default FunctionaryForm;
